import type { IFilter } from '@models/Filter'

import { apiClient } from '../../gateways/api'
import type { ProjectmeldingenSearch } from '../types/ProjectmeldingenSearch'

export { searchProjectmeldingen, createFilters, initialState }

const initialState: ProjectmeldingenSearch = {
  data: { count: 0, skip: 0, limit: 25, items: [] },
  query: {
    filters: {
      statuscode: [{ code: 1010, label: 'Gemeld' }],
      tags: [],
      gebied: [],
      search: '',
    },
    page: { skip: 0, limit: 25 },
    sort: { sortBy: 'created', sortDirection: 'desc' },
  },
}

const createFilters = ({ gebied, statuscode, search, tags }) => {
  const filters: IFilter[] = []

  if (gebied && gebied.length > 0)
    filters.push({
      name: 'gebiedscode',
      value: gebied.map(({ code }) => code),
      operator: 'in',
    })

  if (search) {
    filters.push({
      name: 'search',
      value: search,
      operator: 'eq',
    })
  }

  filters.push({
    name: 'statuscode',
    value: statuscode.map(({ code }) => parseInt(code)),
    operator: 'in',
  })

  if (tags && tags.length > 0) {
    filters.push({
      name: 'tags',
      value: tags.map(({ label }) => label),
      operator: 'in',
    })
  }

  return filters
}

const searchProjectmeldingen = async ({
  query,
}: {
  query: ProjectmeldingenSearch['query']
}): Promise<ProjectmeldingenSearch['data']> => {
  const { filters, page, sort } = query

  const { data } = await apiClient({
    url: '/rest/projectmelding/search',
    method: 'POST',
    data: { filters: createFilters(filters), ...page, ...sort },
  })

  return data
}
